// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3dhUN","footer":"Form_footer__30XFC"};